module.exports = __webpack_public_path__ + "static/media/analogClock.d41a2aea.png";